export function renderPluginStatus(status: 'unchecked' | 'valid' | 'invalid' | null): string {
  let pluginStatus: string;
  if (status === 'valid') {
    pluginStatus = 'Валиден';
  } else {
    if (status === 'invalid') {
      pluginStatus = 'Не валиден';
    } else {
      if (status === 'unchecked') {
        pluginStatus = 'Не проверен';
      } else {
        pluginStatus = '—';
      }
    }
  }
  return pluginStatus;
}
